/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ errorType: NonNullable<unknown> }} Error_Nav_No_Filtered_ErrorsInputs */

const en_error_nav_no_filtered_errors = /** @type {(inputs: Error_Nav_No_Filtered_ErrorsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No ${i?.errorType} errors found for this event.`)
};

const fr_error_nav_no_filtered_errors = /** @type {(inputs: Error_Nav_No_Filtered_ErrorsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aucune erreur ${i?.errorType} trouvee pour cet evenement.`)
};

const de_error_nav_no_filtered_errors = /** @type {(inputs: Error_Nav_No_Filtered_ErrorsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Für dieses Ereignis wurden keine ${i?.errorType}-Fehler gefunden.`)
};

const it_error_nav_no_filtered_errors = /** @type {(inputs: Error_Nav_No_Filtered_ErrorsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nessun errore ${i?.errorType} trovato per questo evento.`)
};

const ru_error_nav_no_filtered_errors = /** @type {(inputs: Error_Nav_No_Filtered_ErrorsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Для данного события ошибок ${i?.errorType} не обнаружено.`)
};

const es_error_nav_no_filtered_errors = /** @type {(inputs: Error_Nav_No_Filtered_ErrorsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se encontraron errores ${i?.errorType} para este evento.`)
};

const zh_cn2_error_nav_no_filtered_errors = /** @type {(inputs: Error_Nav_No_Filtered_ErrorsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`此事件未发现 ${i?.errorType} 错误。`)
};

const ja_error_nav_no_filtered_errors = /** @type {(inputs: Error_Nav_No_Filtered_ErrorsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`このイベントには${i?.errorType} エラーは見つかりませんでした。`)
};

const hi_error_nav_no_filtered_errors = /** @type {(inputs: Error_Nav_No_Filtered_ErrorsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इस इवेंट के लिए कोई ${i?.errorType} त्रुटि नहीं पाई गई।`)
};

const pt_pt2_error_nav_no_filtered_errors = /** @type {(inputs: Error_Nav_No_Filtered_ErrorsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nenhum erro ${i?.errorType} foi encontrado para este evento.`)
};

/**
* | output |
* | --- |
* | "No {errorType} errors found for this event." |
*
* @param {Error_Nav_No_Filtered_ErrorsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_no_filtered_errors = /** @type {((inputs: Error_Nav_No_Filtered_ErrorsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_No_Filtered_ErrorsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_no_filtered_errors(inputs)
	if (locale === "de") return de_error_nav_no_filtered_errors(inputs)
	if (locale === "it") return it_error_nav_no_filtered_errors(inputs)
	if (locale === "ru") return ru_error_nav_no_filtered_errors(inputs)
	if (locale === "es") return es_error_nav_no_filtered_errors(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_no_filtered_errors(inputs)
	if (locale === "ja") return ja_error_nav_no_filtered_errors(inputs)
	if (locale === "hi") return hi_error_nav_no_filtered_errors(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_no_filtered_errors(inputs)
	return en_error_nav_no_filtered_errors(inputs)
});